import { Flex } from '@/UI/styles';
import NodeDataCard from '@/components/Common/NodeDataCard/NodeDataCard';
import { ModelItem } from '@/state/nodes/nodes.types';

export const NodeDetails = ({
  item,
  shouldDisplayEmptyOutput,
}: {
  item: ModelItem;
  shouldDisplayEmptyOutput?: boolean;
}) => {
  return (
    <Flex sx={{ width: 320 }}>
      <NodeDataCard
        displayName={item.displayName}
        description={item.description ?? ''}
        price={item.price ?? 0}
        isVerified={item.isVerified}
        termsUrls={item.termsUrls ?? []}
        privacyUrl={item.privacyPolicyUrl ?? ''}
        inputTypes={item.inputTypes}
        outputTypes={item.outputTypes}
        shouldDisplayEmptyOutput={shouldDisplayEmptyOutput}
      />
    </Flex>
  );
};
